module.exports = __webpack_public_path__ + "img/panelSel.0a2a3ca1.svg";